import { render, staticRenderFns } from "./invoicedetails.vue?vue&type=template&id=58fbba34&"
import script from "./invoicedetails.vue?vue&type=script&lang=js&"
export * from "./invoicedetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports